'use client'

import { useContext, useState } from "react";
import { LiveStreamContext } from "../_config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import useInterval from "@/hooks/useInterval";
import { useTranslations } from "next-intl";

export default function RefreshTimer({setLoading}: {setLoading: Function}){
    const { fetchData } = useContext(LiveStreamContext)
    const { fetchLiveList } = useContext(LiveStreamContext)

    const t = useTranslations('Text')

    const cycle = 60
    const [timer60Second, setTimer60Second] = useState<number>(cycle)

    function refreshFetchData(){        
        setTimer60Second(cycle)
        setLoading(true)
        fetchLiveList()
        setTimeout(()=> {
            setLoading(false);
        }, 1000)
    }

    useInterval(()=> {
        if(timer60Second > 1 && timer60Second <= cycle){
            setTimer60Second(timer60Second - 1)
        }else{
            refreshFetchData()
        }
    }, 1000)

    return (
        <div className="refresh" onClick={refreshFetchData}>
             {t('Timer Before')} <span>{timer60Second}</span>{t.rich('Timer span:color', { s: (chunks)=> <span>{chunks}</span> })} <FontAwesomeIcon icon={faRotateRight} /> {t('Refresh')}
        </div>
    )
}